module.exports = __webpack_public_path__ + "assets/img/youer-070414c8.png";